module.exports = __webpack_public_path__ + "img/Taylors_Bell_Foundry_0186.de8405da.jpg";